import store from '../store';
import Request from './request'
import snackbar from '@/plugins/snackbar';
import i18n from '@/i18n';

async function fetch(data){
    return Request("get","api/distribution-shop-analyze/",data)
}

async function fetchOne(id,data){
    return Request("get","api/distribution-shop-analyze/view?shop_ids=" + id,data)
}

// 一览导出
async function exports(data){
    store.dispatch("fullscreenLoading")
    const response = await Request('get',"api/distribution-shop-analyze/export",data)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop")
    return response
}
// 明细导出
async function detailExports(id, data){
    store.dispatch("fullscreenLoading")
    const response = await Request('get',"api/distribution-shop-analyze/detail-export?shop_ids=" + id, data)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop")
    return response
}

// 批量明细导出
async function batchDetailExports(data){
  store.dispatch("fullscreenLoading")
  const response = await Request('get',"api/distribution-shop-analyze/batch-detail-export", data)
  if(response.data && response.data.status.isOK()){
      snackbar.info(i18n.t("Export.recordedHint"))
  }
  store.dispatch("fullscreenLoadingStop")
  return response
}

export default {
    fetch,
    fetchOne,
    exports,
  detailExports,
  batchDetailExports
}